<template>
  <div>
    <download-excel
      :data="data"
      :fields="json_fields"
      type="xls"
      name="拼团订单图表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }"
        >导出Excel</a-button
      >
    </download-excel>
    <!-- <a-button
      type="primary"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage('/home/tokenPackage/tokenPackageAdd')"
    >
      新增
    </a-button>
    <a-button
      type="danger"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage('/home/lightningDeals/add')"
    >
      新增指删除
    </a-button> -->
    <a-table
      :columns="columns"
      :row-key="(record) => record.orderNo"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="name" slot-scope="name">
        {{ name.first }} {{ name.last }}
      </template>
      <!-- 商品图片 -->
      <template slot="pic2" slot-scope="text, record">
        <img class="img2" :src="record.goodsRecord[0].goodsImg" alt="" />
      </template>
      <template slot="goodsName" slot-scope="text, record">
        <span>{{ record.goodsRecord[0].goodsName }}</span>
      </template>
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, operate">
        <a
          href=""
          v-on:click.prevent="
            topage(
              `/home/seckillOrder/seckillOrderDetails?orderNo=${operate.orderNo}`,
              operate.orderNo
            )
          "
          >订单详情</a
        >
        <!-- <a
          href=""
          v-on:click.prevent="topage('/home/memberManagement/userPullsNew')"
          >确认领取</a
        >
        <a v-on:click.prevent="showModal">取消订单</a> -->
        <!-- <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal> -->
      </template>
    </a-table>
  </div>
</template>
<script>
import { seckillList } from "@/api/hometwoApi.js";

const columns = [
  {
    title: "订单编号",
    dataIndex: "orderNo",
    // sorter: true,
    align: "center",
    scopedSlots: { customRender: "orderNo" },
  },
  {
    title: "商品名称",
    dataIndex: "goodsName",
    align: "center",
    scopedSlots: { customRender: "goodsName" },
  },
  {
    title: "商品图片",
    dataIndex: "goodsImg",
    align: "center",
    scopedSlots: { customRender: "pic2" },
  },
  {
    title: "用户uid",
    dataIndex: "userUid",
    // sorter: true,
    align: "center",

    scopedSlots: { customRender: "userUid" },
  },
  {
    title: "订单数量",
    dataIndex: "goodsNum",
    // sorter: true,
    align: "center",
    scopedSlots: { customRender: "goodsNum" },
  },
  {
    title: "订单金额",
    dataIndex: "pricePay",
    // sorter: true,
    align: "center",
    scopedSlots: { customRender: "pricePay" },
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    // sorter: true,,
    align: "center",

    scopedSlots: { customRender: "shopName" },
  },
  {
    title: "操作",
    dataIndex: "name",
    // sorter: true,
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      json_fields: {},
      loading: false,
      columns,
      visible: false,
      limit: 10,
      page: 1,
      goodsRecord: [],
    };
  },
  mounted() {
    // this.getUserListDetails();
    this.getData();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      seckillList({ limit: 10, page: this.pagination.current }).then((res) => {
        var data = res.data;
        for (var i = 0; i < data.length; i++) {
          var item = data[i].goodsRecord;
          //console.log('item',item)
          if (item) {
            var goodsdata = JSON.parse(data[i].goodsRecord);
            console.log("--------------------", goodsdata);
            data[i].goodsRecord = goodsdata;
          }
        }
        this.data = data;
        this.loading = false;
      });
    },
    // 查询
    query() {
      console.log("e");
      this.loading = true;
      seckillList(this.formInline).then((res) => {
        var data = res.data;
        for (var i = 0; i < data.length; i++) {
          var item = data[i].goodsRecord;
          //console.log('item',item)
          if (item) {
            var goodsdata = JSON.parse(data[i].goodsRecord);
            console.log("--------------------", goodsdata);
            data[i].goodsRecord = goodsdata;
          }
        }
        this.data = data;

        console.log(this.data, "-----data");
        this.loading = false;
      });
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    getData() {
      seckillList({ page: 1, limit: 10 }).then((res) => {
        this.pagination.total = res.count;
        var data = res.data;
        for (var i = 0; i < data.length; i++) {
          var item = data[i].goodsRecord;
          //console.log('item',item)
          if (item) {
            var goodsdata = JSON.parse(data[i].goodsRecord);
            console.log("--------------------", goodsdata);
            data[i].goodsRecord = goodsdata;
          }
        }
        this.data = data;
        console.log(this.data, "-----data");
      });
    },
  },
};
</script>
<style scoped>
.img2 {
  width: 100px;
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/orderManagement/seckillOrder/seckillOrderContent.vue